import React from 'react';
import { PhoneIcon } from 'lucide-react';
interface PhoneInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}
export function PhoneInput({
  value,
  onChange,
  error
}: PhoneInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/\D/g, '');
    if (input.length <= 10) {
      onChange(input);
    }
  };
  return <div className="space-y-2" data-id="element-83">
      <label className="block text-sm font-medium text-gray-700" data-id="element-84">
        Numéro de téléphone
      </label>
      <div className="relative" data-id="element-85">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-86">
          <PhoneIcon className="w-5 h-5 text-gray-400" data-id="element-87" />
        </div>
        <div className="absolute inset-y-0 left-12 flex items-center pointer-events-none" data-id="element-88">
          <span className="text-gray-700 font-medium" data-id="element-89">+225</span>
        </div>
        <input type="tel" value={value} onChange={handleChange} placeholder="0123456789" className={`w-full pl-24 pr-4 py-4 text-lg border-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all ${error ? 'border-red-300 focus:border-red-500' : 'border-gray-200 focus:border-amber-500'}`} data-id="element-90" />
      </div>
      {error && <p className="text-sm text-red-600" data-id="element-91">{error}</p>}
      <p className="text-xs text-gray-500" data-id="element-92">
        Entrez votre numéro sans le code pays
      </p>
    </div>;
}